<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-31 10:18:15
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:56:53
 * @Description: file content
 -->
<template>
  <div class="container" v-if="pageInfo">
    <div
      class="imagetext_content rich_media_content"
      v-html="pageInfo.Imagetext"
    ></div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
  },
  props: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
  },
  created() {
    let that = this;
    util.checkMapStateCallback(that, [ "pageInfo"]).then(() => {
    
    });
    
  },
  mounted() {
    
  }
};
</script>
<style lang="css" scoped>
</style>